/**
 * Overlay action executors — dispatch overlay commands to the OverlayRenderer.
 */

import type { GlassOverlayRenderer } from '../ui/components/overlayCard'

export class OverlayActions {
  private renderer: GlassOverlayRenderer

  constructor(renderer: GlassOverlayRenderer) {
    this.renderer = renderer
  }

  showTextCard(title: string, body: string): { status: string } {
    this.renderer.showTextCard(title, body)
    console.log(`[OverlayActions] Showing text card: "${title}"`)
    return { status: 'shown' }
  }

  showImageCard(imageUrl: string, caption?: string): { status: string } {
    this.renderer.showImageCard(imageUrl, caption)
    console.log(`[OverlayActions] Showing image card: "${caption ?? imageUrl}"`)
    return { status: 'shown' }
  }

  showBulletList(title: string, items: string[]): { status: string } {
    this.renderer.showBulletList(title, items)
    console.log(`[OverlayActions] Showing bullet list: "${title}" (${items.length} items)`)
    return { status: 'shown' }
  }

  dismissAll(): { status: string } {
    this.renderer.dismissAll()
    console.log('[OverlayActions] Dismissed all overlays')
    return { status: 'dismissed' }
  }
}
